import React, { Component } from 'react';
import { Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { find, get, debounce, map } from 'lodash';
import { Link } from 'react-router-dom';
//import ComparisonDetails from './Details';
import ComparisonRows from './ComparisonRows';
import sample from './sample.json';
import IncomeChart from '../../components/pages/comparison/IncomeChart';
import SearchWidget from '../../components/pages/home/SearchWidget';
import { searchActions } from '../../data/actions/search';
import CSV from '../../helpers/CSVExport';
import SharePage from '../../components/pages/sharedPages/SharePage';

const shareSvg = require('!svg-inline-loader!../../../public/img/icons/share.svg');
const downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');

class ComparisonList extends Component {
	constructor(props) {
		super(props);
		const months = get(props.filter, 'global.monthsSinceRelease', 1);
		const entities = [];
		
		this.state = {
			months,
			baseEntity: null,
			entities
		};
		
	}
	
	pendingAdds = 0;
	
	addEntity = (entity) => {
		let { entities, months, baseEntity } = this.state;
		const { user, history } = this.props;
		entity = this.formatEntity(entity, months);
		if(find(entities, e=>(e.id == entity.id && e.entity == entity.entity))) {
			alert('This entity is already selected for comparison, please choose another one.');
			return;
		}
		if(baseEntity && baseEntity != entity.entity) {
			alert('Only entities of the same type can be compared.');
			return;
		}
		
		if(new Date(entity.releaseDate) < new Date(user.user.first_data_date)) {
			return alert(`The data requested is outside of the date range available.`);
		}

		this.setState({
			entities: [...entities, entity],
			baseEntity: entity.entity
		}, ()=>{
			const entities = map(this.state.entities, 'id');
			history.push(`/comparison/${this.state.baseEntity}/${entities.join(',')}`);	
		})
		
		
	}


	
	exportToXlsReady = () => {
		const entityMap = {
			'top_products': 'products.top.ID.loading',
			'top_artists': 'artists.top.ID.loading',
			'top_tracks': 'tracks.top.ID.loading',
			'top_territories': 'stats.territories.ID.loading',
			'top_vendors': 'stats.vendors.ID.loading'
		};
		const ids = map(this.state.entities, 'id');
		if(!ids.length)
			return false;
		
		for(let entity of Object.keys(entityMap)){
			for(let id of ids){
				let pageKey = entityMap[entity].replace('ID', id);
				let ready = !get(this.props, pageKey, false);
				if(!ready)
					return false;
			}
		}
		return true;
	}
	
	exportToXls = () => {
		const entityMap = {
			'top_products': 'products.top.ID.data',
			'top_artists': 'artists.top.ID.data',
			'top_tracks': 'tracks.top.ID.data',
			'top_territories': 'stats.territories.ID.data.table',
			'top_vendors': 'stats.vendors.ID.data.table'
		};
		const ids = map(this.state.entities, 'id');
		let pages = [];
		for(let entity of Object.keys(entityMap)){
			let page = [];
			for(let id of ids){
				let pageKey = entityMap[entity].replace('ID', id);
				let entityPage = get(this.props, pageKey);
				for(let row of entityPage) {
					row['base_entity'] = id;
					page.push(row);
				}
			}
			pages.push({[entity]: page}); 
		}
		return CSV.CSVBulkExport(pages, `comparison_${ids.join('_')}`);
		
	}
	
	deleteEntity = (id, type) => {
		let { entities, baseEntity } = this.state;
		entities = entities.filter(e=>(e.id !== id));
		baseEntity = entities.length > 0 ? baseEntity : null; // reset type filter when there are no selected elements
		this.setState({
			entities,
			baseEntity
		}, ()=>{
			const entities = map(this.state.entities, 'id');
			history.push(`/comparison/${this.state.baseEntity}/${entities.join(',')}`);	
		})
	}
	
	formatEntity = (entity, months) => {
		const { code, entity: entity_type, first_released, name } = entity;
		const dateStart = moment(first_released).endOf('month');
		const dateEnd = dateStart.clone().add(months, 'months').endOf('month');
		
		return {
			id: code,
			entity: entity_type,
			title: name,
			releaseDate: first_released,
			dateStart: dateStart.format('YYYY-MM-DD'),
			dateEnd: dateEnd.format('YYYY-MM-DD')		
		}
	}


	componentDidMount(){
		const { match: {params: { type, entities: ids } = {} }, dispatch } = this.props;
		if(type && ids) {
			const idsArray = ids.split(',');
			dispatch(searchActions.getSearchAutocomplete(idsArray.join('\r\n'), idsArray.length, [type])).then(results=>{
				let { entities, months } = this.state;
				for(let result of results[type]) {
					entities.push(this.formatEntity(result, months));
				}
				this.setState({
					entities,
					baseEntity: type
				})
			})
		}
	}
	


	componentWillUnmount() {
	}
	
	componentDidUpdate(prevProps) {
		const prevMonths = get(prevProps.filter, 'global.monthsSinceRelease');
		const nextMonths = get(this.props.filter, 'global.monthsSinceRelease');
		if(prevMonths && prevMonths != nextMonths){
			let { entities } = this.state;
			
			this.setState({
				entities: []
			}, ()=>{
				entities = entities.map(e=>{
					const dateEnd = moment(e.dateStart).add(nextMonths, 'months').endOf('month');
					return {
						...e,
						dateEnd: dateEnd.format('YYYY-MM-DD')
					};
				})
				this.setState({
					months: nextMonths,
					entities
				})
			})
		}
	}
	
	renderSearchBox() {
		const { baseEntity } = this.state;
		const entityTypes = baseEntity ? [baseEntity] : ['projects', 'products', 'tracks'];
		const placeholder = `Search ${entityTypes.join(', ')}.`
		return <SearchWidget searchResult={this.addEntity} placeholder={placeholder} entityTypes={entityTypes} baseEntity mode="playlist" />
	}
	
	renderEntities(entities){
		if(!Array.isArray(entities) || !entities.length)
			return null;
		const type = this.state.baseEntity;
		return <div className="comparison-search-result-list" key={`${type}`}>
			<div className="tag-list">
				<div className="page-filter-item">
					<div className="page-filter-list">
						{entities.map((entity, i) =><div key={entity.id} className="comparison-entity-item">
							<span className="comparison-entity-name">#{i + 1}</span>
							<div className={`page-filter ${entity.entity}`}>
								<div className="tag">
									<div className="tag-name-holder">
										<div className="tag-name">
											<span>{entity.title} released on {entity.releaseDate}</span>
										</div>
										<a
											className="close-link"
											onClick={()=>this.deleteEntity(entity.id, type)}
										>
											&times;
										</a>
									</div>
								</div>
							</div>
							</div>)}
					</div>
				</div>
			</div>
		</div>

	}

	
	render() {
		const { entities = [], baseEntity } = this.state;
		const ids = map(this.state.entities, 'id');
		const comparisonSearchClass = `${entities.length > 2 ? 'more-comparison-items' : ''}`;
		const { sharedMode = false } = this.props;
		
		return <div className="wrapper wrapper-content">
			<div className='container'>
				<div className="comparison-title-container">
					<h2 className="main-title main-title--mb">Comparison
						<div className="comparison-subtitle">Compare performance from initial release date of multiple projects, products, or tracks
						</div>
						<div className="report-warning">These reports are for analytical purposes only and should not be used to pay artist royalties
						</div>
					</h2>
					<div className="share-page-btn-holder">
							{sharedMode &&  <a key="download"  className="default-btn default-btn--small button-icon share-page-btn" title="Download entire page" onClick={this.exportToXls}>Export Page</a>}
							{!sharedMode && <SharePage entity={baseEntity} module="comparison" id={ids.join(',')} exportToCsv={this.exportToXls} forceShow={this.exportToXlsReady} CSVEntities={[]} flatCSVExport={true} />}

						{/*{this.exportToXlsReady() && 
							<button type="button" onClick={this.exportToXls} className="default-btn default-btn--small button-icon share-page-btn">
								Export Page
								<span className="chart-icon chart-icon--small" dangerouslySetInnerHTML={{__html: shareSvg}}></span>
							</button>
						}*/}
						
					</div>
				</div>
			</div>
			<div className="container comparison-sticky-container">
				<div className="comparison-search-container">
					{this.renderSearchBox()}
					{this.renderEntities(entities)}
				</div>
			</div>
			
			{entities.length > 0 && <div className="todo">
				<IncomeChart entities={entities} />
			</div>}
			
			{/*
			<div className="comparison-wrapper">
				{entities.map(entity=><ComparisonDetails key={entity.id} entity={entity} />)}
			</div>
			*/}
			
			<div className={comparisonSearchClass}>
				<ComparisonRows entities={entities} />
			</div>
			
		</div>

	}
	
}

function mapStateToProps(state) {
	return {
		filter: state.filter,
		products: state.products, 
		artists: state.artists,
		tracks: state.tracks,
		stats: state.stats,
		user: state.user 
	}
}


export default withRouter(connect(mapStateToProps)(ComparisonList));